/**
 * Navigation item visibility rules by role
 * Used to dynamically filter navigation based on user role
 */
export const NAVIGATION_ITEM_ACCESS: Record<string, UserRole[]> = {
    // Home
    'home': ['admin', 'captain', 'player', 'external_player'],

    // League items
    'league': ['admin', 'captain', 'player'],
    'league.summary': ['admin', 'captain', 'player'],
    'league.team': ['admin', 'captain', 'player'],
    'league.schedule': ['admin', 'captain', 'player'],
    'league.standings': ['admin', 'captain', 'player'],
    'league.management': ['admin', 'captain'], // Captain/admin only

    // Catalanas items
    'catalanas': ['admin', 'captain', 'player', 'external_player'],
    'catalanas.overview': ['admin', 'captain', 'player', 'external_player'],
    'catalanas.history': ['admin', 'captain', 'player', 'external_player'],
    'catalanas.management': ['admin', 'captain'], // Solo admin/capi

    // Stats
    'stats': ['admin', 'captain', 'player', 'external_player'],

    // Settings (captain + admin — fine-grained by sub-route)
    'settings': ['admin', 'captain', 'player', 'external_player'],
} as const;

export type UserRole = 'admin' | 'captain' | 'player' | 'external_player';
export type NavigationItemId = keyof typeof NAVIGATION_ITEM_ACCESS;
